<script setup>
import {computed} from 'vue'

const props = defineProps({
    maxlength: {
        type: Number,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    },
})

// --- Computed ---

const remaining = computed(() => {
    // Convert to string to handle Number types and calculate length safely
    const strValue = (props.value ?? '') + ''
    return props.maxlength - strValue.length
})
</script>

<template>
    <small class="float-end p-1 text-body-secondary" title="The number of allowed characters remaining">
        {{ remaining }}
    </small>
</template>

<style scoped>
/* Scoped styles preserved */
</style>